import { api } from './api';
import {
  AnalyticsDateRange,
  UsersAnalytics,
  BookingsAnalytics,
  PaymentsAnalytics,
  ContentAnalytics,
  GroupSessionsAnalytics,
  SupportAnalytics,
} from '../types/analytics';

const BASE_PATH = '/admin/analytics';

// ============================================================================
// Analytics API Service
// ============================================================================

// Helper to unwrap { success, data } API response envelope
function unwrap<T>(responseData: any): T {
  if (responseData && typeof responseData === 'object' && 'data' in responseData) {
    return responseData.data as T;
  }
  return responseData as T;
}

export const getUsersAnalytics = async (
  params?: AnalyticsDateRange
): Promise<UsersAnalytics> => {
  const response = await api.get(`${BASE_PATH}/users`, { params });
  return unwrap<UsersAnalytics>(response.data);
};

export const getBookingsAnalytics = async (
  params?: AnalyticsDateRange
): Promise<BookingsAnalytics> => {
  const response = await api.get(`${BASE_PATH}/bookings`, { params });
  return unwrap<BookingsAnalytics>(response.data);
};

export const getPaymentsAnalytics = async (
  params?: AnalyticsDateRange
): Promise<PaymentsAnalytics> => {
  const response = await api.get(`${BASE_PATH}/payments`, { params });
  return unwrap<PaymentsAnalytics>(response.data);
};

export const getContentAnalytics = async (
  params?: AnalyticsDateRange
): Promise<ContentAnalytics> => {
  const response = await api.get(`${BASE_PATH}/content`, { params });
  return unwrap<ContentAnalytics>(response.data);
};

export const getGroupSessionsAnalytics = async (
  params?: AnalyticsDateRange
): Promise<GroupSessionsAnalytics> => {
  const response = await api.get(`${BASE_PATH}/group-sessions`, { params });
  return unwrap<GroupSessionsAnalytics>(response.data);
};

export const getSupportAnalytics = async (
  params?: AnalyticsDateRange
): Promise<SupportAnalytics> => {
  const response = await api.get(`${BASE_PATH}/support`, { params });
  return unwrap<SupportAnalytics>(response.data);
};

export const analyticsService = {
  getUsersAnalytics,
  getBookingsAnalytics,
  getPaymentsAnalytics,
  getContentAnalytics,
  getGroupSessionsAnalytics,
  getSupportAnalytics,
};

export default analyticsService;
